import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { GoogleLogin } from '@react-oauth/google';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";

const MerchantSignup = () => {
  const [address, setAddress] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [referralCode, setReferralCode] = useState('');


  //merchant
  const [merchantName, setMerchantName] = useState('');
  const [brandName, setBrandName] = useState('');
  const [industry, setIndustry] = useState('');
  const [category, setCategory] = useState('');
  const [mobile, setMobile] = useState('');
  const [adminId, setAdminId] = useState(0);
  const [merchatSiteUrl, setMerchatSiteUrl] = useState('');
  const [userName, setUserName] = useState('');
  const [passwordResetToken, setPasswordResetToken] = useState('');
  const [resetTokenExpiryDate, setResetTokenExpiryDate] = useState('');
  const [emailConfirmationToken, setEmailConfirmationToken] = useState('');
  const [isEmailConfirmed, setIsEmailConfirmed] = useState(true);
  const [referredByType, setReferredByType] = useState('Merchant');
  const [registeredOn, setRegisteredOn] = useState('');
  const [referredByCode, setReferredByCode] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [error, setError] = useState('');

  const [eyePassword, setEyePassword] = useState(false)
  const [confirmEyePassword, setConfirmEyePassword] = useState(false)

  const [showEyePassword, setShowEyePassword] = useState(false)
  const [showConfirmEyePassword, setShowConfirmEyePassword] = useState(false)


  const navigate = useNavigate();

  const { id } = useParams();
  const currentDate = new Date();


  useEffect(() => {
    setResetTokenExpiryDate(currentDate)
    setReferredByCode(id || '')
    setRegisteredOn(currentDate)
  }, [])



  const handleGoogleLoginSuccess = (credentialResponse) => {
    debugger
    const token = credentialResponse.credential;
    const decoded = jwtDecode(token);


    const userData = {
      name: decoded.name,
      email: decoded.email,
      picture: decoded.picture,
    };

    axios
      .post("https://api.bakpoket.com/api/Auth/google-login", {
        name: userData.name,
        Username: userData.name,
        email: userData.email,
      })
      .then((res) => {
        alert("Login Success")
      })
      .catch((err) => {
        console.error("Login Failed:", err);
        alert("Login Failed");
      });


    localStorage.setItem('merchantLogin', JSON.stringify(userData));
    localStorage.setItem('googleLogin', true);
    setUserName(decoded.name || '');
    setEmail(decoded.email || '');
    navigate("/merchant/dashboard")
    // window.location.reload();

  };


  const formHandling = async (e) => {
    e.preventDefault();

    // password validation
    if (password.length < 8) {
      setError("Password must be at least 8 characters long");
      return;
    }

    if (confirmPassword !== password) {
      setError("Password and ConformPassword must be same");
      return;
    }

    // mobile validation
    if (!/^[0-9]{10}$/.test(mobile)) {
      setError("Mobile number must be exactly 10 digits and only contain numbers");
      return;
    }

    try {
      const response = await axios.post('https://api.bakpoket.com/api/MerchantDetails', {
        merchantName,
        brandName,
        industry,
        category,
        address,
        email,
        mobile,
        adminId,
        merchatSiteUrl,
        userName,
        password,
        passwordResetToken,
        resetTokenExpiryDate,
        emailConfirmationToken,
        isEmailConfirmed,
        referredByCode,
        referralCode,
        referredByType,
        registeredOn
      });
      // console.log(response)

      alert('Merchant Sign-up successful!');
      navigate('/MerchantSignin')

    } catch (error) {
      if (error.response) {
        setError(error.response.data);
        alert(`Sign-up failed: ${error.response.data.message || 'Please try again.'}`);
      } else {
        console.error('Error:', error.message);
        alert('Sign-up failed. Please check your connection.');
      }
    }
  };

  return (
    <div className='container my-3'>
      <Wrapper>
        <div className="main-card">
          <h6 className="top-text">Get more business with free coupon posting on BakPoket!</h6>
          <h6>Sign Up with BakPoket</h6>

          <div className="login-options">
            <div className="login-type">
              <GoogleLogin
                onSuccess={(response) => handleGoogleLoginSuccess(response, false)}
                onError={() => console.log('Google Login Failed')}
              />
            </div>
          </div>


          <div className="or-divider"><span>OR</span></div>

          <form className="signup-form" onSubmit={formHandling}>
            <input type="text" placeholder="User Name" value={userName} onChange={(e) => setUserName(e.target.value)} required />
            <input type="text" placeholder="Merchant Name" value={merchantName} onChange={(e) => setMerchantName(e.target.value)} required />
            {/* <input type="text" placeholder="Brand Name" value={brandName} onChange={(e) => setBrandName(e.target.value)} required /> */}
            <input type="text" placeholder="Category" value={category} onChange={(e) => setCategory(e.target.value)} required />
            <input type="email" placeholder="Email Address" value={email} onChange={(e) => setEmail(e.target.value)} required />
            <input type="text" placeholder="Merchant Site URL" value={merchatSiteUrl} onChange={(e) => setMerchatSiteUrl(e.target.value)} />
            <input type="text" placeholder="Mobile" value={mobile} onChange={(e) => setMobile(e.target.value)} required />

            <div style={{ position: 'relative' }}>
              <input type={showEyePassword?'text':'password'} placeholder="Password must contain 8 characters" value={password} onChange={(e) => {
                setPassword(e.target.value)
                if (e.target.value.length >= 8) setError('');
              }} required style={{ width: '100%' }} />
              {password.length >0?(
                eyePassword ? (<FaEyeSlash style={{ position: 'absolute', right: '10', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }} onClick={()=>{setEyePassword(false);setShowEyePassword(false)}} />) 
                : (<FaEye style={{ position: 'absolute', right: '10', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }} onClick={()=>{setEyePassword(true);setShowEyePassword(true)}}  />)):(null)
              }
            </div>


            <div style={{ position: 'relative' }}>
              <input type={showConfirmEyePassword ?'text':'password'} placeholder="Confirm Password" value={confirmPassword} onChange={(e) => {
                setConfirmPassword(e.target.value)
                if (e.target.value === password) setError('');
              }} required style={{ width: '100%' }} />
              {confirmPassword.length >0?(
                confirmEyePassword ? (<FaEyeSlash style={{ position: 'absolute', right: '10', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }} onClick={()=>{setConfirmEyePassword(false);setShowConfirmEyePassword(false)}} />) 
                : (<FaEye style={{ position: 'absolute', right: '10', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }} onClick={()=>{setConfirmEyePassword(true);setShowConfirmEyePassword(true)}} />)):(null)
              }
            </div>

            <input type="text" placeholder="Use Referral" value={referredByCode} onChange={(e) => setReferredByCode(e.target.value)} disabled />
            <div className="agreement">
              <input type="checkbox" required />
              <p>I agree with the <NavLink to='/merchantterms-service' >Terms & Conditions</NavLink></p>
            </div>
            {error && <p className='mb-0' style={{ color: "red", fontSize: "12px" }}>{error}</p>}
            <button type="submit" className="signup-btn">SIGN UP</button>
          </form>
          <SwitchText>
            Already have an account? <span><NavLink to='/MerchantSignin' style={{ textDecoration: 'none', color: '#ef4766' }}>Sign In</NavLink></span>
          </SwitchText>
        </div>
      </Wrapper>
    </div>
  )
}

export default MerchantSignup


const Wrapper = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;

  .main-card {
    background-color: rgb(233, 231, 231);
    width: 100%;
    max-width: 500px;
    padding: 15px 30px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    text-align: center;
    height:auto;
  }

  .top-text {
    font-weight: bold;
    color: #444;
    margin-bottom: 5px;
  }

  h2 {
    margin-bottom: 5px;
    color: #222;
  }

  .login-options {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 0px;
  }

  .login-type {
    display: flex;
    justify-content: center;
  }

  .or-divider {
    display: flex;
    align-items: center;
    text-align: center;
    margin: 4px 0;

    span {
      background-color: rgba(71, 70, 70, 0.1);
      padding: 3px;
      color: #666;
      font-weight: 600;
      border-radius: 50%;
    }

    &::before,
    &::after {
      content: '';
      flex: 1;
      height: 1px;
      background: #999;
    }
  }

  .signup-form {
    display: flex;
    flex-direction: column;
    gap: 2px;

    // max-height: 50vh;
    // overflow-y: auto;
    padding-right: 5px;

    scrollbar-width: thin;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 4px;
    }

    input {
      padding: 7px;
      border-radius: 6px;
      border: 1px solid #ccc;
      font-size: 13px;
    }
  }

  .agreement {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 2px 0;

    p {
      margin: 0;
      font-size: 10px;
    }

    a {
      color: #ef4766;
      font-weight: bold;
      cursor: pointer;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .signup-btn {
    background-color: #ef4766;
    color: white;
    border: none;
    padding: 10px;
    border-radius: 6px;
    font-weight: bold;
    width: 100%;
    font-size: 15px;
    // margin-top: 10px;
    cursor: pointer;
    transition: background 0.3s ease;

    &:hover {
      background-color: #d91212;
    }
  }

  @media (max-width: 600px) {
    .main-card {
      padding: 7.5px;
    }

    h2 {
      font-size: 15px;
      margin-bottom: 5px;
    }

    .top-text {
      font-size: 10px;
      margin-bottom: 2px;
    }

    .signup-btn {
      font-size: 14px;
      padding: 8px;
    }

    input {
      font-size: 10px;
    }

    .agreement p {
      font-size: 9px;
    }

    .signup-btn {
      font-size: 12px;
      padding: 7px;
    }

    .or-divider {
      margin: 5px 0;
    }
  }
`;


const SwitchText = styled.p`
  font-size: 13px;
  margin-top: 10px;
  margin-bottom: 0px;

  span {
    color: #ef4766;
    cursor: pointer;
    font-weight: bold;
  }

  @media (max-width: 600px) {
    font-size: 9px;
    margin-bottom: 2px;
    margin-top: 2px;
  }
`;

